import React, { useState } from "react";
import { jsPDF } from "jspdf";
import Namuna8Form from "./Namuna8Form";
import "./MilkatKarAakarni.css";

const MilkatKarAakarni = () => {
  const [form, setForm] = useState({
    ward: "",
    anuNo: "",
    propertyNo: "",
    owner: "",
    occupier: "",
    gharpatti: "",
    divabatti: "",
    arogya: "",
    visheshPani: "",
    samanyaPani: ""
  });

  const [data, setData] = useState([
    {
      id: 1,
      ward: "वॉर्ड 1",
      anuNo: "101",
      propertyNo: "11",
      owner: "स्वप्निल",
      occupier: "स्वप्निल",
      gharpatti: 362353.00,
      divabatti: 10.00,
      arogya: 10.00,
      visheshPani: 0,
      samanyaPani: 50.00
    },
    {
      id: 2,
      ward: "वॉर्ड 2",
      anuNo: "102",
      propertyNo: "14",
      owner: "अभी लांबे",
      occupier: "अभी लांबे",
      gharpatti: 500.00,
      divabatti: 10.00,
      arogya: 10.00,
      visheshPani: 0,
      samanyaPani: 121.00
    }
  ]);

  const [search, setSearch] = useState("");
  const [editId, setEditId] = useState(null);
  const [showNamuna8Modal, setShowNamuna8Modal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = () => {
    if (!form.ward || !form.propertyNo || !form.owner) {
      alert("कृपया आवश्यक माहिती भरा");
      return;
    }

    if (editId) {
      setData(
        data.map((item) =>
          item.id === editId
            ? {
                ...form,
                id: editId,
                gharpatti: Number(form.gharpatti || 0),
                divabatti: Number(form.divabatti || 0),
                arogya: Number(form.arogya || 0),
                visheshPani: Number(form.visheshPani || 0),
                samanyaPani: Number(form.samanyaPani || 0)
              }
            : item
        )
      );
      setEditId(null);
      alert("नोंदी यशस्वीरित्या अपडेट झाली! ✅");
    } else {
      setData([
        ...data,
        {
          id: Date.now(),
          ...form,
          gharpatti: Number(form.gharpatti || 0),
          divabatti: Number(form.divabatti || 0),
          arogya: Number(form.arogya || 0),
          visheshPani: Number(form.visheshPani || 0),
          samanyaPani: Number(form.samanyaPani || 0)
        }
      ]);
      alert("नोंदी यशस्वीरित्या जतन झाली! ✅");
    }
    handleReset();
  };

  const handleReset = () => {
    setForm({
      ward: "",
      anuNo: "",
      propertyNo: "",
      owner: "",
      occupier: "",
      gharpatti: "",
      divabatti: "",
      arogya: "",
      visheshPani: "",
      samanyaPani: ""
    });
    setEditId(null);
  };

  const handleEdit = (item) => {
    setForm(item);
    setEditId(item.id);
  };

  const handleDelete = (id) => {
    if (window.confirm("हे रेकॉर्ड हटवायचं आहे का?")) {
      setData(data.filter((item) => item.id !== id));
      if (editId === id) {
        handleReset();
      }
    }
  };

  const calculateTotal = () => {
    return (
      Number(form.gharpatti || 0) +
      Number(form.divabatti || 0) +
      Number(form.arogya || 0) +
      Number(form.visheshPani || 0) +
      Number(form.samanyaPani || 0)
    ).toFixed(2);
  };

  const generatePDF = async (specificId = null) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();

      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("मिळकत कर आकारणी", pageWidth / 2, 10, { align: "center" });

      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);

      const exportData = specificId
        ? data.filter((item) => item.id === specificId)
        : data;

      const tableData = exportData.map((item, index) => [
        index + 1,
        item.propertyNo,
        item.owner,
        item.occupier,
        item.gharpatti.toFixed(2),
        item.divabatti.toFixed(2),
        item.arogya.toFixed(2),
        item.samanyaPani.toFixed(2),
        (
          item.gharpatti +
          item.divabatti +
          item.arogya +
          item.visheshPani +
          item.samanyaPani
        ).toFixed(2)
      ]);

      pdf.autoTable({
        head: [
          [
            "अ.क्र.",
            "मालमत्ता नं",
            "मालकाचे नाव",
            "भोगवटाधारक",
            "घरपट्टी",
            "दिवाबत्ती",
            "आरोग्य",
            "पाणी कर",
            "एकूण कर"
          ]
        ],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [241, 244, 255],
          textColor: [44, 62, 80],
          fontStyle: "bold",
          fontSize: 10
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 9
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250]
        }
      });

      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(
          `पृष्ठ ${i} / ${pageCount}`,
          pageWidth / 2,
          pdf.internal.pageSize.getHeight() - 10,
          { align: "center" }
        );
      }

      const fileName = specificId
        ? `कर-आकारणी-${specificId}.pdf`
        : `कर-आकारणी-यादी.pdf`;
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  const filteredData = data.filter(
    (item) =>
      item.propertyNo.toLowerCase().includes(search.toLowerCase()) ||
      item.owner.toLowerCase().includes(search.toLowerCase()) ||
      item.occupier.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="milkat-container">
      <div className="header">मिळकत कर आकारणी</div>

      {/* Namuna8 Form Modal */}
      {showNamuna8Modal && (
        <Namuna8Form onClose={() => setShowNamuna8Modal(false)} />
      )}

      {/* Action Button */}
      <div className="action-button-section">
        <button 
          className="btn-namuna8"
          onClick={() => setShowNamuna8Modal(true)}
        >
          📋 नमुना नं ८ - नवीन माहिती भरणे
        </button>
      </div>

      {/* Edit Mode Banner */}
      {editId && (
        <div className="edit-mode-banner">
          ✏️ संपादन मोड - रेकॉर्ड ID: {editId}
        </div>
      )}

      {/* Form Section */}
      <div className="form-section">
        <h3 className="form-title">नमुना नं / कर गणना</h3>

        <div className="form-wrapper">
          {/* Row 1 */}
          <div className="form-row">
            <div className="form-field">
              <label>वॉर्डचे नाव <span className="required">*</span></label>
              <input
                type="text"
                name="ward"
                value={form.ward}
                onChange={handleChange}
                placeholder="उदा. वॉर्ड 1"
              />
            </div>
            <div className="form-field">
              <label>अनु नं</label>
              <input
                type="text"
                name="anuNo"
                value={form.anuNo}
                onChange={handleChange}
                placeholder="उदा. 101"
              />
            </div>
            <div className="form-field">
              <label>मालमत्ता क्र <span className="required">*</span></label>
              <input
                type="text"
                name="propertyNo"
                value={form.propertyNo}
                onChange={handleChange}
                placeholder="उदा. 11"
              />
            </div>
          </div>

          {/* Row 2 */}
          <div className="form-row">
            <div className="form-field">
              <label>मालकाचे नाव <span className="required">*</span></label>
              <input
                type="text"
                name="owner"
                value={form.owner}
                onChange={handleChange}
                placeholder="उदा. स्वप्निल"
              />
            </div>
            <div className="form-field">
              <label>भोगवटाधारकाचे नाव</label>
              <input
                type="text"
                name="occupier"
                value={form.occupier}
                onChange={handleChange}
                placeholder="उदा. स्वप्निल"
              />
            </div>
          </div>

          {/* Tax Row 1 */}
          <div className="form-row">
            <div className="form-field">
              <label>घरपट्टी</label>
              <input
                type="number"
                name="gharpatti"
                value={form.gharpatti}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
              />
            </div>
            <div className="form-field">
              <label>दिवाबत्ती कर</label>
              <input
                type="number"
                name="divabatti"
                value={form.divabatti}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
              />
            </div>
            <div className="form-field">
              <label>आरोग्य कर</label>
              <input
                type="number"
                name="arogya"
                value={form.arogya}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
              />
            </div>
          </div>

          {/* Tax Row 2 */}
          <div className="form-row">
            <div className="form-field">
              <label>विशेष पाणी कर</label>
              <input
                type="number"
                name="visheshPani"
                value={form.visheshPani}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
              />
            </div>
            <div className="form-field">
              <label>सामान्य पाणी कर</label>
              <input
                type="number"
                name="samanyaPani"
                value={form.samanyaPani}
                onChange={handleChange}
                placeholder="0.00"
                step="0.01"
              />
            </div>
            <div className="form-field total-field">
              <label>एकूण कर</label>
              <div className="total-value">₹ {calculateTotal()}</div>
            </div>
          </div>

          {/* Buttons */}
          <div className="form-buttons">
            <button className="btn btn-save" onClick={handleSubmit}>
              {editId ? "अपडेट करा" : "जतन करा"}
            </button>
            <button className="btn btn-reset" onClick={handleReset}>
              रीसेट करा
            </button>
          </div>
        </div>
      </div>

      {/* Search Section */}
      <div className="search-section">
        <div className="search-field">
          <label>शोधा (मालमत्ता नं / मालकाचे नाव)</label>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="शोधा..."
          />
        </div>
        <div className="search-info">
          एकूण नोंदी: <strong>{filteredData.length}</strong>
        </div>
      </div>

      {/* Table Section */}
      <div className="table-section">
        <div className="table-header">
          <h3>मिळकत कर आकारणी यादी</h3>
          <div className="pdf-buttons">
            <button className="btn-pdf-all" onClick={() => generatePDF()}>
              📄 सर्व PDF
            </button>
            {data.length > 0 && (
              <button
                className="btn-pdf-specific"
                onClick={() => {
                  if (editId) {
                    generatePDF(editId);
                  } else {
                    alert("कृपया संपादित करायचा रेकॉर्ड निवडा");
                  }
                }}
              >
                📋 विशिष्ट PDF
              </button>
            )}
          </div>
        </div>

        <table className="data-table">
          <thead>
            <tr>
              <th>अ.क्र.</th>
              <th>मालमत्ता नं</th>
              <th>मालकाचे नाव</th>
              <th>भोगवटाधारक</th>
              <th>घरपट्टी</th>
              <th>दिवाबत्ती</th>
              <th>आरोग्य</th>
              <th>पाणी कर</th>
              <th>एकूण कर</th>
              <th>क्रिया</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.length > 0 ? (
              filteredData.map((item, index) => (
                <tr
                  key={item.id}
                  className={editId === item.id ? "editing" : ""}
                >
                  <td>{index + 1}</td>
                  <td>{item.propertyNo}</td>
                  <td>{item.owner}</td>
                  <td>{item.occupier}</td>
                  <td>₹{item.gharpatti.toFixed(2)}</td>
                  <td>₹{item.divabatti.toFixed(2)}</td>
                  <td>₹{item.arogya.toFixed(2)}</td>
                  <td>₹{item.samanyaPani.toFixed(2)}</td>
                  <td className="total">
                    ₹
                    {(
                      item.gharpatti +
                      item.divabatti +
                      item.arogya +
                      item.visheshPani +
                      item.samanyaPani
                    ).toFixed(2)}
                  </td>
                  <td className="action-buttons">
                    <button
                      className="btn-edit"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn-delete"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="10" className="empty-state">
                  कोणती नोंदी सापडली नाही
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default MilkatKarAakarni;
